// @flow

import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import GenerateReportButton from '../Buttons/GenerateReportButton'
import Paginate from '../Buttons/Paginate'
import { time } from '../timeutils'
import Loading from '../Icons/loading.gif'
import './ContentTable.css'

import commentIcon from '../Icons/icon-social-comment.svg'
import likeIcon from '../Icons/icon-social-like.svg'
import notifyIcon from '../Icons/icon-social-notify.svg'
import newsFeedIcon from '../Icons/icon-social-newsfeed.svg'
import mentionIcon from '../Icons/icon-social-mention.svg'
import secureIcon from '../Icons/icon-social-secure.svg'
import disableIcon from '../Icons/icon-social-disable.svg'
import linkIcon from '../Icons/icon-social-link.svg'
import thumbnailIcon from '../Icons/icon-social-thumbnail.svg'

type Props = {
  changeOffset: Function,
  toggleSort: Function,
  data: Array,
  page: number,
  totalContent: number,
  generateReportClick: Function,
  status: String,
  toggleSort: Function,
  sort: String,
  accountDetails: Object
}

/**
  * Diplay for content table
  * @class
  * @extends Component
*/
class ContentTable extends Component<Props> {
  renderSocialIcons = (entry) => {
    const iconImgs = []
    if (entry.notify) {
      iconImgs.push(<img src={notifyIcon} alt='' title='Push Notifications Enabled' className='tablethumb social-icon' />)
    }
    if (entry.includeInFeed) {
      iconImgs.push(<img src={newsFeedIcon} alt='' title='Show in Newsfeed' className='tablethumb social-icon' />)
    }
    if (entry.secure) {
      iconImgs.push(<img src={secureIcon} alt='' title='Read Receipts Enabled' className='tablethumb social-icon' />)
    }
    if (entry.disableSaving) {
      iconImgs.push(<img src={disableIcon} alt='' title='Saving and Downloads Disabled' className='tablethumb social-icon' />)
    }
    if (entry.likesEnabled) {
      iconImgs.push(<img src={likeIcon} alt='' title='Likes Enabled' className='tablethumb social-icon' />)
    }
    if (entry.commentsEnabled) {
      iconImgs.push(<img src={commentIcon} alt='' title='Comments Enabled' className='tablethumb social-icon' />)
    }
    if (entry.mentionsEnabled) {
      iconImgs.push(<img src={mentionIcon} alt='' title='MentionsEnabled' className='tablethumb social-icon' />)
    }
    if (entry.displayThumbnail) {
      iconImgs.push(<img src={thumbnailIcon} alt='' title='Thumbnail Enabled' className='tablethumb social-icon' />)
    }
    if (entry.isQuickLink) {
      iconImgs.push(<img src={linkIcon} alt='' title='Quick Link Enabled' className='tablethumb social-icon' />)
    }

    if (iconImgs.length === 0) {
      return <span className='no-social'>No Social Enabled</span>
    }
    return iconImgs
  }

  determineContentTypeImage = (content) => {
    let image

    switch (content.contentType) {
      case 'CONTENT_WEB': {
        image = 'https://cdn-public-assets.theemployeeapp.com/content-icons/icon-web-link.svg'
        break
      }
      case 'CONTENT_IMAGE': {
        image = 'https://cdn-public-assets.theemployeeapp.com/content-icons/icon-images.svg'
        break
      }
      case 'CONTENT_PDF': {
        image = 'https://cdn-public-assets.theemployeeapp.com/content-icons/icon-pdf.svg'
        break
      }
      case 'CONTENT_AUDIO': {
        image = 'https://cdn-public-assets.theemployeeapp.com/content-icons/icon-audio.svg'
        break
      }
      case 'CONTENT_VIDEO': {
        image = 'https://cdn-public-assets.theemployeeapp.com/content-icons/icon-video.svg'
        break
      }
      case 'CONTENT_RICH_TEXT': {
        image = 'https://cdn-public-assets.theemployeeapp.com/content-icons/icon-rich-text.svg'
        break
      }
      case 'CONTENT_DOCX': {
        image = 'https://cdn-public-assets.theemployeeapp.com/content-icons/icon-docx.svg'
        break
      }
      case 'CONTENT_PPTX': {
        image = 'https://cdn-public-assets.theemployeeapp.com/content-icons/icon-pptx.svg'
        break
      }
      case 'CONTENT_XLSX': {
        image = 'https://cdn-public-assets.theemployeeapp.com/content-icons/icon-xlsx.svg'
        break
      }
      case 'CONTENT_MISC': {
        image = 'fa fa-images'
        break
      }
    }

    return image
  }

  /** render function */
  render () {
    const header = (<tr>
      <th id={this.props.sort.split(' ')[0] === 'title' ? 'contentHeader' : ''} style={{ cursor: 'default' }} >
        <span style={{ cursor: 'default' }}>Content</span></th>
      <th id={this.props.sort.split(' ')[0] === 'totalViews' ? 'contentHeader' : ''} style={{ cursor: 'default' }}>
        <span>Total Views</span></th>
      <th id={this.props.sort.split(' ')[0] === 'totalViewsWeb' ? 'contentHeader' : ''} className={this.props.sort.split(' ')[0] === 'totalViewsWeb' ? (this.props.sort.split(' ')[1] === 'DESC' ? 'downSort' : 'upSort') : ''} onClick={(e) => this.props.toggleSort('totalViewsWeb')}>
        <span>Desktop</span></th>
      <th id={this.props.sort.split(' ')[0] === 'totalViewsMobile' ? 'contentHeader' : ''} className={this.props.sort.split(' ')[0] === 'totalViewsMobile' ? (this.props.sort.split(' ')[1] === 'DESC' ? 'downSort' : 'upSort') : ''} onClick={(e) => this.props.toggleSort('totalViewsMobile')}>
        <span>Mobile</span></th>
      <th id={this.props.sort.split(' ')[0] === 'totalLikes' ? 'contentHeader' : ''} style={{ cursor: 'default' }}>
        <span style={{ cursor: 'default' }}>{ this.props.accountDetails && this.props.accountDetails.ui_version === 'v1' ? 'Reactions' : 'Likes' }</span></th>
      <th id={this.props.sort.split(' ')[0] === 'totalComments' ? 'contentHeader' : ''} style={{ cursor: 'default' }}>
        <span style={{ cursor: 'default' }} >Comments</span></th>
      <th id={this.props.sort.split(' ')[0] === 'avgDurationInApp' ? 'contentHeader' : ''} style={{ cursor: 'default' }}>
        <span>Avg Duration Mobile</span></th>
      <th id={this.props.sort.split(' ')[0] === 'avgDurationInCMS' ? 'contentHeader' : ''} style={{ cursor: 'default' }}>
        <span>Avg Duration Web</span></th>
      <th style={{ cursor: 'default' }}>
        <span>Social Enabled</span></th>
    </tr>)
    const content = this.props.data.map((entry) => {
      if (entry.title === 'Loading') {
        return (<tr key={'Loading'}><td><img src={Loading} alt='Loading' /></td></tr>)
      } else if (entry.title.indexOf('DELETED') !== -1) {
        return (
          <tr key={Math.random()}>
            <Link to={{ pathname: '/content', search: '?id=' + entry._id + '&date=Week&filter=__' }} style={{ pointerEvents: 'none' }}>
              <td>
              {entry.thumbnailUrl === 'fa fa-images' ? <i className='img-gallery-icon'></i> : <img src={entry.thumbnailUrl || this.determineContentTypeImage(entry)} alt='' className='tablethumb' />}
              <span className='truncate'>{entry.title}</span></td>
            </Link>
          </tr>
        )
      } else {
        return (
          <tr key={Math.random()}>
            <Link to={{ pathname: '/content', search: '?id=' + entry._id + '&date=Week&filter=__' }}>
              <td>{entry.thumbnailUrl === 'fa fa-images' ? <i className='img-gallery-icon'></i> : <img src={entry.thumbnailUrl || this.determineContentTypeImage(entry)} alt='' className='tablethumb' />}<span className='truncate'>{entry.title}</span></td>
            </Link>
            <td>{entry.totalViews.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
            <td>{entry.totalViewsWeb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
            <td>{entry.totalViewsMobile.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
            {
              this.props.accountDetails && this.props.accountDetails.ui_version === 'v1'
                ? <td>{entry.totalReactions.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
                : <td>{entry.totalLikes.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
            }
            <td>{entry.totalComments.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
            <td>{time(entry.avgDurationInApp)}</td>
            <td>{time(entry.avgDurationInCMS)}</td>
            <td>{this.renderSocialIcons(entry)}</td>
          </tr>
        )
      }
    })

    return (
      <div>
        <div className='table-wrapper'>
          <div className='ContentTable table-wrapper'>
            <h4 className='flex align-center space-between'>
              Content Information Table
              <GenerateReportButton status={this.props.status} generateReportClicked={this.props.generateReportClick} />
            </h4>
            <table>
              <thead>{header}</thead>
              <tbody>{content}</tbody>
            </table>
          </div>
        </div>
        <Paginate changePage={(i) => this.props.changeOffset(i)} page={this.props.page} length={this.props.totalContent} />
      </div>
    )
  }
}

export default ContentTable
